<template>
  <el-dropdown trigger="click" hide-on-click>
    <span class="el-dropdown-link">
<!--      <ElIcons name="Avatar" style="margin-right: 6px;" :size="16"/>-->
      <img src="../../assets/image/avatar.png" style="width: 24px; height: 24px; border-radius: 50%; overflow:hidden; margin-right: 8px;" alt="" />
      {{ sysUserName }}
      <ElIcons name="ArrowDownBold" style="margin-left: 8px;" :size="8"/>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
<!--        <el-dropdown-item>-->
<!--          <ElIcons name="EditPen" style="margin-right: 12px;"/>修改密码-->
<!--        </el-dropdown-item>-->
        <el-dropdown-item @click="logout">
          <ElIcons name="SwitchButton" style="margin-right: 12px;"/>退出登陆
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
import { signOut, addOrUpdateUser } from '@/api/url'
import { getFormData } from '@/api/api'
export default {
  name: "UserInfo",
  data() {
    return {
      sysUserName: JSON.parse(sessionStorage.getItem('account'))
    }
  },
  methods: {
    logout() {
      var _this = this;
      getFormData(signOut).then(() => {
        // sessionStorage.removeItem('account');
        // localStorage.removeItem('menuList');
        // sessionStorage.removeItem('navArray');
        sessionStorage.clear()
        localStorage.clear()
        _this.$store.dispatch('delAllViews')
        _this.$router.push('/');
      })
    }
  }
}
</script>

<style scoped>

</style>
